import React, {Component} from 'react';
import {Translation} from 'react-i18next';
import {Button, Card, Col, Row, Space, Spin} from 'antd';
import {LoadingOutlined, PlusCircleOutlined} from '@ant-design/icons';

import ResourceCategoriesList from '../containers/ResourceCategoriesListContainer';
import ResourceCategoriesCSVButton from '../containers/ResourceCategoriesCSVButtonContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import {pathTo} from '../../../Routes';
import Config from '../../../../../Config';
import QueryString from '../../../../../lib/QueryString';
import Logger from '../../../../../lib/Logger';

class ResourceCategoriesScreen extends Component {

  static defaultProps = {
    limit: Config.get('DEFAULT_LIST_LENGTH', 10),
    isLoading: true,
  }

  scrollToTop = () => {
    Logger.log('debug', `ResourceCategoriesScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {

    const loadingIcon = <Spin indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />} />;
    const page = parseInt(this.props.match.params.page ? this.props.match.params.page : 1);
    const {order, ...filter} = QueryString.parse(this.props.location.search);

    return (
      <Translation>{(t) => 
        <div>

          <DocumentHead title={t('resource_categories_route_list')} />

          <Row>
            <Col span={24}>
              <Card
                title={
                  <Space size={10}>
                    {t('resource_categories_list_title')}
                    <Button
                      size="small"
                      icon={<PlusCircleOutlined />}
                      onClick={e => this.props.history.push(pathTo('ResourceCategoryAddScreen'))}
                    >
                      {t('action_create')}
                    </Button>
                    <ResourceCategoriesCSVButton order={order} filter={filter} />
                  </Space>
                }
                extra={this.props.isLoading ? loadingIcon : null}
              >
                <ResourceCategoriesList
                  key={page}
                  component="ResourceCategoriesScreen"
                  page={page}
                  limit={this.props.limit}
                  order={order || 'order.asc'}
                  filter={filter}
                />
              </Card>
            </Col>
          </Row>

        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default ResourceCategoriesScreen;

Logger.log('silly', `ResourceCategoriesScreen loaded.`);